import { WidgetModel } from './widget.model';

export class ForumFeedWidgetModel extends WidgetModel {}
